import { Modal } from '@dynamika-shared/ui/Modal/Modal';
import { FC } from 'react';
import { SubscriptionContent } from '@dynamika-shared/types/subscription';

type DeleteSubscriptionModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  subscription?: SubscriptionContent;
  loading?: boolean;
};

export const DeleteSubscriptionModal: FC<DeleteSubscriptionModalProps> = ({
  open,
  onClose,
  onConfirm,
  subscription,
  loading = false,
}) => {
  if (!subscription) return null;

  return (
    <Modal
      width={440}
      onCancel={onClose}
      onOk={onConfirm}
      okText='Remove'
      centered
      cancelText='Cancel'
      maskClosable={false}
      open={open}
      loading={loading}
      okClassName='!bg-vermilion hover:!bg-vermilion/90'
      classNames={{
        header: 'text-left !mb-3',
        content: 'text-center !rounded-modal !p-5',
        footer: 'flex justify-between !mt-3',
      }}
      title='Subscriber Removal'
      titleClassName='text-left font-sans text-1824 font-medium'
      data-testid='delete-subscription-modal'
    >
      <p className='font-nunito text-1824 text-black'>
        Are you sure you want to remove this subscriber?
      </p>
    </Modal>
  );
};
